import { websockets } from '../../../engine/websockets-sidecar'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { chessWebsockets } from '../messages/chessWebsockets-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'

export interface IChessUiGameMultiplayer extends IChessUiCanvas {}

let _obj: IChessUiGameMultiplayer | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(true)
  }
  return _obj
}
const create = () => {
  let tw = 0
  let th = 0
  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IChessUiCanvas = chessUiCanvas.assign<IChessUiGameMultiplayer>(
    canvas,
    {},
  )

  return obj
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
}

export const render = () => {
  let obj = get()
  let g = obj.graphics

  chessUiCanvas.clear(obj)

  let gb = chessCamera.getGameBounds()

  let x = gb.width - 180
  let y = 20

  let w = 500
  let h = 300
  let sy = y
  let sx = x

  let addText = (text: string, ox: number = 0, oy: number = 0) => {
    let t = chessUiCanvas.addText2(
      obj,
      text,
      chessFonts.get().f,
      x + ox,
      y + oy,
      3,
    )
    stevieTexts2.setScale(t, 0.33)
    // stevieTexts2.setWrapWidth(t, w - 60)
    y += 30
    return t
  }

  let addSpacer = () => {
    y += 30
  }

  addText(
    websockets.getConnectionStatus() +
      ' ' +
      (chessWebsockets.getIsHost() ? 'Host' : 'Client'),
  )
  addText('Game ' + websockets.getChannel())
  // addText(
  //   'Id: ' +
  //     chessWebsockets.getMultiId() +
  //     ' - ' +
  //     chessWebsockets.getMultiName(),
  // )
  addText(chessWebsockets.getMultiName())
  let ping = '' + chessWebsockets.getPingTime()
  if (ping !== '999') {
    //ping = '-'
    addText('' + ping + ' ms ping')
  }

  chessUiCanvas.render(obj)
}

export const update = () => {
  let obj = get()
  if (obj.isOpen) {
    chessUiCanvas.update(obj)
    render()
  }
}
